"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var BillableItemResource = /** @class */ (function (_super) {
    tslib_1.__extends(BillableItemResource, _super);
    function BillableItemResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BillableItemResource.endpoint = '/billableitems';
    BillableItemResource.MODEL_NAME = 'billableitem';
    return BillableItemResource;
}(base_1.default));
exports.default = BillableItemResource;
//# sourceMappingURL=billableitem.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/transactions/billableitem.js
// module id = URrW
// module chunks = 0